export default __webpack_public_path__ + "static/media/70.4ee7c69b.svg";